import { ChatDotsIcon } from '@nimbus-ds/icons';
import { MenuButton } from '@nimbus-ds/patterns';
import { useTranslation } from 'react-i18next';
import { useLocation, Link } from 'react-router-dom';
import { useHandleMenuClick } from 'App/hooks';
import { infoMessageRoutes } from './infoMessageRoutes';

export function InfoMessageMenu() {
  const { t } = useTranslation('common');
  const { pathname } = useLocation();
  const { handleClickItem } = useHandleMenuClick();

  return (
    <MenuButton
      as={Link}
      to={infoMessageRoutes.infoMessage}
      startIcon={ChatDotsIcon}
      onClick={handleClickItem}
      active={pathname.startsWith(infoMessageRoutes.infoMessage)}
      label={t('settingsMenu.communication.infoMessage')}
    />
  );
}
